"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsVirtualKeyboard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSimpleKeyboard = _interopRequireDefault(require("react-simple-keyboard"));
require("react-simple-keyboard/build/css/index.css");
require("./DmsVirtualKeyboard.css");
var _reactDraggable = _interopRequireDefault(require("react-draggable"));
var _KeyboardLayouts = require("../../constants/KeyboardLayouts");
var _material = require("@mui/material");
var _iconsMaterial = require("@mui/icons-material");
var _LanguageEnum = require("../../constants/LanguageEnum");
var _dmsbasereact = require("dmsbasereact");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DmsVirtualKeyboard = _ref => {
  let {
    showKeyboard,
    focus,
    currentInputValue,
    setShowKeyboard
  } = _ref;
  const [layout, setLayout] = (0, _react.useState)("default");
  const [keyboardLanguage, setKeyboardLanguage] = (0, _react.useState)(_KeyboardLayouts.KeyboardLayout[_LanguageEnum.Languages.EN_US]);
  const [currentLanguageIndex, setCurrentLanguageIndex] = (0, _react.useState)(0);
  const [isKeyboardEnabledBySystem, setIsKeyboardEnabledBySystem] = (0, _react.useState)(false);
  const keyboardRef = (0, _react.useRef)(null);
  const keyboardWrapperRef = (0, _react.useRef)(null);
  const languages = [_LanguageEnum.Languages.EN_US, _LanguageEnum.Languages.PT_BR, _LanguageEnum.Languages.ES_MX];
  const fetchSystemSettings = (0, _react.useCallback)(async () => {
    try {
      const {
        data: systemSettings
      } = await (0, _dmsbasereact.fetchData)('/system_settings', 'get', false);
      const settings = await systemSettings;
      if (settings.data && settings.data.keyboard === 'USE VIRTUAL KEYBOARD') {
        setIsKeyboardEnabledBySystem(true);
      } else {
        setIsKeyboardEnabledBySystem(false);
      }
    } catch (error) {
      console.error("Could not fetch system settings:", error);
      setIsKeyboardEnabledBySystem(false);
    }
  }, []);
  (0, _react.useEffect)(() => {
    fetchSystemSettings();
  }, [fetchSystemSettings]);
  (0, _react.useEffect)(() => {
    const handleSettingsChange = () => {
      fetchSystemSettings();
    };
    window.addEventListener('system-settings-changed', handleSettingsChange);
    return () => {
      window.removeEventListener('system-settings-changed', handleSettingsChange);
    };
  }, [fetchSystemSettings]);
  (0, _react.useEffect)(() => {
    if (showKeyboard && keyboardWrapperRef.current) {
      keyboardWrapperRef.current.style.zIndex = "2147483647";
    }
  }, [showKeyboard]);
  (0, _react.useEffect)(() => {
    if (!isKeyboardEnabledBySystem) return;
    const handleInputFocus = event => {
      const target = event.target;
      const nodeName = target.nodeName;
      const inputType = target.type ? target.type.toLowerCase() : 'text';
      const nonTextInputs = ['checkbox', 'radio', 'button', 'submit', 'reset', 'file', 'image', 'color', 'range', 'date', 'month', 'week', 'time', 'datetime-local'];
      if (nodeName === 'TEXTAREA' || nodeName === 'INPUT' && !nonTextInputs.includes(inputType)) {
        setShowKeyboard(true);
      }
    };
    document.addEventListener("focusin", handleInputFocus);
    return () => {
      document.removeEventListener("focusin", handleInputFocus);
    };
  }, [isKeyboardEnabledBySystem, setShowKeyboard]);
  (0, _react.useEffect)(() => {
    if (!showKeyboard) return;
    const handleClickOutside = event => {
      if (keyboardWrapperRef.current && keyboardWrapperRef.current.contains(event.target)) {
        return;
      }
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
        return;
      }
      setShowKeyboard(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showKeyboard, setShowKeyboard]);
  (0, _react.useEffect)(() => {
    setKeyboardLanguage(_KeyboardLayouts.KeyboardLayout[languages[currentLanguageIndex]]);
  }, [currentLanguageIndex]);
  const onChangeAll = newInput => {
    var _focus$currentInputVa;
    if (!currentInputValue) return;
    const input = document.getElementById((_focus$currentInputVa = focus[currentInputValue]) === null || _focus$currentInputVa === void 0 ? void 0 : _focus$currentInputVa.id);
    if (input) {
      const event = new Event("input", {
        bubbles: true
      });
      Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set.call(input, newInput[currentInputValue]);
      input.dispatchEvent(event);
    }
  };
  const handleKeyPress = button => {
    const actions = {
      "{shift}": () => setLayout(layout === "default" ? "shift" : "default"),
      "{bksp}": () => handleBackspace(),
      "{numbers}": () => toggleLayout("numbers"),
      "{special}": () => toggleLayout("special"),
      "{abc}": () => setLayout("default"),
      "{language}": () => cycleLanguage(),
      "{tab}": () => handleTab()
    };
    if (actions[button]) actions[button]();
  };
  const handleBackspace = () => {
    var _focus$currentInputVa2;
    const input = document.getElementById((_focus$currentInputVa2 = focus[currentInputValue]) === null || _focus$currentInputVa2 === void 0 ? void 0 : _focus$currentInputVa2.id);
    if (input) {
      const currentText = input.value || "";
      const newText = currentText.slice(0, -1);
      const event = new Event("input", {
        bubbles: true
      });
      Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set.call(input, newText);
      input.dispatchEvent(event);
    }
  };
  const handleTab = () => {
    const inputs = document.querySelectorAll("input, textarea, [tabindex]");
    const currentInput = document.activeElement;
    if (currentInput) {
      const currentIndex = Array.from(inputs).indexOf(currentInput);
      const nextIndex = (currentIndex + 1) % inputs.length;
      inputs[nextIndex].focus();
    }
  };
  const toggleLayout = targetLayout => {
    setLayout(layout === targetLayout ? "default" : targetLayout);
  };
  const cycleLanguage = () => {
    setCurrentLanguageIndex(prevIndex => (prevIndex + 1) % languages.length);
  };
  const languageFlag = {
    [_LanguageEnum.Languages.EN_US]: "🇺🇸",
    [_LanguageEnum.Languages.PT_BR]: "🇧🇷",
    [_LanguageEnum.Languages.ES_MX]: "🇲🇽"
  };
  if (!showKeyboard || !isKeyboardEnabledBySystem) {
    return null;
  }
  return /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/_react.default.createElement(_reactDraggable.default, {
    axis: "both",
    handle: ".keyboard-header",
    nodeRef: keyboardWrapperRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dms-virtual-keyboard",
    ref: keyboardWrapperRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "keyboard-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "keyboard-header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "language-info"
  }, languageFlag[languages[currentLanguageIndex]]), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    onClick: () => setShowKeyboard(false),
    onTouchStart: () => setShowKeyboard(false)
  }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.Close, null))), /*#__PURE__*/_react.default.createElement(_reactSimpleKeyboard.default, {
    keyboardRef: r => keyboardRef.current = r,
    inputName: currentInputValue,
    layoutName: layout,
    layout: keyboardLanguage,
    onChangeAll: onChangeAll,
    onKeyPress: handleKeyPress,
    display: {
      "{language}": "🌐",
      "{special}": "/!?",
      "{abc}": "ABC",
      "{numbers}": "123",
      "{space}": "␣",
      "{shift}": "⇧",
      "{bksp}": "←",
      "{tab}": "↹",
      "{enter}": "⏎"
    }
  })))), document.body);
};
exports.DmsVirtualKeyboard = DmsVirtualKeyboard;
DmsVirtualKeyboard.propTypes = {
  showKeyboard: _propTypes.default.bool.isRequired,
  focus: _propTypes.default.object,
  currentInputValue: _propTypes.default.string,
  setShowKeyboard: _propTypes.default.func.isRequired
};